import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/web/components/navigation/MainNav.js");
;
import(/* webpackMode: "eager" */ "/code/web/node_modules/@referralexchange/rea-ui-react/src/components/footer/Footer.module.scss");
;
import(/* webpackMode: "eager" */ "/code/web/node_modules/@referralexchange/rea-ui-react/src/components/navigation/HeadingWithLinks.module.scss");
;
import(/* webpackMode: "eager" */ "/code/web/components/FooterCities.module.scss");
;
import(/* webpackMode: "eager" */ "/code/web/components/Footer.module.scss");
;
import(/* webpackMode: "eager" */ "/code/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/code/web/node_modules/next/dist/client/link.js");
